import { combineReducers } from 'redux';
import session from './session';
import categories from './categories';
import workspaces from './workspaces';
import sets from './sets';
import workspacePreview from './workspacePreview';
import umoGallery from './umoGallery';
import mainUI from './mainUI';
import messageDialog from './messageDialog';
import metaAttach from './metaAttach';
import umoUtils from './umoUtils';
import userList from './userList';
import thesaurus from './thesaurus';
import { LOGIN_REQUEST } from '../actions/sessionActionTypes';


const app = combineReducers({
  messageDialog,
  session,
  categories,
  workspaces,
  sets,
  workspacePreview,
  umoGallery,
  mainUI,
  metaAttach,
  umoUtils,
  userList,
  thesaurus,
});

const rootReducer = (state, action = {}) => {
  if (action.type === LOGIN_REQUEST) {
    const initialState = app(undefined, {});
    initialState.session = initialState.session
      .set('sessionState', action.type)
    ;
    return initialState;
  }/* else if (action.type === SESSION_EXPIRED) {
    const initialState = app(undefined, {});
    initialState.session = initialState.session
      .set('sessionState', LOGIN_REQUIRED)
      .set('sessionStateMessage', SESSION_RELOGIN_MESSAGE)
    ;
    return initialState;
  }*/
  return app(state, action);
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/js/reducers/index.js